
<div class="val-grille-recherche val-flex-conteneur val-flex-colonne">
  <div class="val-grille-recherche-bandeau">
    <val-bandeau-recherche [ngClass]="{'val-invisible': tailleBandeau === 0}"
                           [lignes]="lignesBandeau"
                           [taille]="tailleBandeau"
                           [identifiantRecherche]="identifiantRecherche"
                           (rafraichir)="RafraichirBandeauEvenement()">
    </val-bandeau-recherche>
  </div>
  <div class="val-grille-recherche-onglets">
    <val-barre-onglets  #barreOnglets
                        [onglets]="onglets"
                        (ongletSelectionneChange)="ExecuterActionSurChangementOnglet($event)"
                        (rafraichissementOngletDemande)="ExecuterActionSurRafraichissementOnglet($event)">
    </val-barre-onglets>
  </div>
  <div class="val-grille-recherche-conteneur val-flex-1 val-flex-conteneur">
    <div class="val-grille-recherche-panel val-flex-conteneur val-flex-colonne"
         [class.ouvert]="panelOuvert"
         [class.ferme]="!panelOuvert"
         [style.--largeur]="largeurPanel + 'px'">
      <div class="val-grille-recherche-panel-ouvrir-fermer val-flex-conteneur"
           (click)="OuvrirFermerPanel()">
        <val-fonte-icone iconeCss="fas fa-chevron-double-right"
                         [utiliserRotation270]="true"
                         [rotation]="panelOuvert">
        </val-fonte-icone>
        <div class="val-flex-1"></div>
      </div>
      <div class="val-grille-recherche-panel-contenu val-flex-1">
        <div class="val-grille-recherche-exporter-excel val-flex-conteneur"
             [title]="Texte('exporter-infobulle', 'Exporter vers Excel')"
             (click)="ExporterVersExcel()">
          <val-fonte-icone iconeCss="fas fa-file-excel">
          </val-fonte-icone>
          <val-simple-libelle [libelle]="Texte('exporter', 'Exporter')"></val-simple-libelle>
        </div>
        <div class="val-grille-recherche-reinitialiser val-flex-conteneur"
             [title]="Texte('reinitialiser-infobulle', 'Réinitialiser filtres et tri')"
             (click)="ReinitialiserFiltresEtTri()">
          <val-fonte-icone iconeCss="fas fa-undo-alt">
          </val-fonte-icone>
          <val-simple-libelle [libelle]="Texte('reinitialiser', 'Réinitialiser')"></val-simple-libelle>
        </div>
      </div>
    </div>
    <val-grille #grille
                class="val-flex-1"
                [colonnes]="colonnes"
                champSelection="PK"
                [donnees]="donneesGrille"
                [groupable]="true"
                [filtrageServeur]="true"
                [taillePage]="taillePage"
                (donneesSuivante)="ChargerDonneesPageSuivante($event)"
                (selectionChange)="ExecuterActionSurChangementSelection($event)"
                (doubleClick)="ExecuterActionSurDoubleClick()"
                (trisChange)="ExecuterActionSurChangementTris($event)"
                (filtresChange)="ExecuterActionSurChangementFiltres($event)"
                (ordresChange)="ExecuterActionSurChangementOrdres($event)"
                (visibiliteColonnesChange)="ExecuterActionSurChangementVisibilite($event)"
                (tailleColonneChange)="ExecuterActionSurChangementTaille($event)"
                (groupeColonnesChange)="ExecuterActionSurChangementGroupe($event)"
                (colonneBoutonIconeClick)="colonneBoutonIconeClick.emit($event)">
    </val-grille>
  </div>
</div>
<val-attente-operation  [visible]="operationEnCours"></val-attente-operation>